import { render, staticRenderFns } from "./VrContainer.vue?vue&type=template&id=63055a24&"
import script from "./VrContainer.vue?vue&type=script&lang=js&"
export * from "./VrContainer.vue?vue&type=script&lang=js&"
import style0 from "./VrContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63055a24')) {
      api.createRecord('63055a24', component.options)
    } else {
      api.reload('63055a24', component.options)
    }
    module.hot.accept("./VrContainer.vue?vue&type=template&id=63055a24&", function () {
      api.rerender('63055a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/VrContainer.vue"
export default component.exports